import constant from "../constant";
const initialState = {
  loaded: false,
  loading: false,
  data: {
    pendingOrders: 0,
    otherPending: 0,
  }
};

const pending = (state = initialState, action) => {
  switch (action.type) {
    case constant.PENDING_LOADING:
      return { ...state, loading: true, loaded: false };
    case constant.ADD_PENDING_LIST:
      let data = { ...state.data, ...action.payload }
      return { loaded: true, loading: false, data };
    case constant.NEW_ORDER_RECEIVED:
      let updatedOrderCount = ""
      if (action.payload > 0) {
        updatedOrderCount = state.data.pendingOrders + 1;
      } else {
        updatedOrderCount = (state.data.pendingOrders - 1) < 0 ? 0 : state.data.pendingOrders - 1;
      }
      let newData = { ...state.data, pendingOrders: updatedOrderCount }
      return { loaded: true, loading: false, data: newData };
    default:
      return state;
  }
}



export default pending;